export const loadImg = {
  PP1: "./image/PetPlace/PP_main.png",
  PP2: "./image/PetPlace/PP_category.png",
  PP3: "./image/PetPlace/PP_error.png",
  PP4: "./image/PetPlace/PP_mobile.png",

  Profile: "./image/profile_character.svg",
  Favicon: "./image/favicon.svg",

  Blog: "./image/velog.svg",
  Resume: "./image/document.svg",
  Email: "./image/Email.svg",
  Github: "./image/github.svg",
  Depo: "./image/deployment.svg",

  ArtMate_P1: "./image/ArtMate/ArtMate_Main1.png",
  ArtMate_P2: "./image/ArtMate/ArtMate_Page1.jpg",
  ArtMate_P3: "./image/ArtMate/ArtMate_Page2.jpg",
  ArtMate_B: "./image/ArtMate/ArtMate_Banner.png",

  ArtMateMobile_P1: "./image/ArtMateApp/ArtMateApp_Main1.png",
  ArtMateMobile_P2: "./image/ArtMateApp/ArtMateApp_Main2.png",
  ArtMateMobile_P3: "./image/ArtMateApp/ArtMateApp_Art1.png",
  ArtMateMobile_P4: "./image/ArtMateApp/ArtMateApp_Art2.png",
  ArtMateMobile_P5: "./image/ArtMateApp/ArtMateApp_Gall1.png",
  ArtMateMobile_P6: "./image/ArtMateApp/ArtMateApp_Gall2.png",

  Bucket_P1: "./image/BucketList/Bucket_Dashboard_all.png",
  Bucket_P2: "./image/BucketList/Bucket_Dashboard_tr.png",
  Bucket_P3: "./image/BucketList/Bucket_Explore_fun.png",
  Bucket_P4: "./image/BucketList/Bucket_Explore_tr.png",
  Bucket_P5: "./image/BucketList/Bucket_Main.png",
  Bucket_P6: "./image/BucketList/Bucket_Main_2.png",

  Portfolio_P1: "./image/Portfolio/Portfolio_about.png",
  Portfolio_P2: "./image/Portfolio/Portfolio_project.png",
  Portfolio_P3: "./image/Portfolio/Portfolio_skill.png",
  Portfolio_P4: "./image/Portfolio/Portfolio_mobile_about.png",
  Portfolio_P5: "./image/Portfolio/Portfolio_mobile_project.png",
  Portfolio_P6: "./image/Portfolio/Portfolio_mobile_project_2.png",
  Portfolio_P7: "./image/Portfolio/Portfolio_mobile_skill.png",
  Portfolio_P8: "./image/Portfolio/Portfolio_mobile_skill2.png",
};
